export const environment = {
  production: true,
  hmr: false,
  sharedConfig: {
    applicationName: 'LenderHub',
  },
  sentry: {
    dsn: 'https://dd5dfb6855684759d036bb0979b141ee@sentry.theidolops.com/73',
  },
};
